import { TenantEntity } from '../TenantEntity'

export class OpenPriceBatch extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'OpenPriceBatch'
  }

  get branchId() {
    return this._data.branchId
  }

  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }

  get filingBatchNo() {
    return this._data.filingBatchNo
  }

  set filingBatchNo(filingBatchNo) {
    this._data.filingBatchNo = filingBatchNo || ''
  }

  get filingState() {
    return this._data.filingState
  }

  set filingState(filingState) {
    this._data.filingState = filingState || 0
  }

  get filingRemark() {
    return this._data.filingRemark
  }

  set filingRemark(filingRemark) {
    this._data.filingRemark = filingRemark || ''
  }

  get filingDate() {
    return this._data.filingDate
  }

  set filingDate(filingDate) {
    this._data.filingDate = filingDate
  }

  get effectiveDate() {
    return this._data.effectiveDate
  }

  set effectiveDate(effectiveDate) {
    this._data.effectiveDate = effectiveDate
  }

  get submitDate() {
    return this._data.submitDate
  }

  set submitDate(submitDate) {
    this._data.submitDate = submitDate
  }

  get submitBy() {
    return this._data.submitBy
  }

  set submitBy(submitBy) {
    this._data.submitBy = submitBy || 0
  }

  get rpaState() {
    return this._data.rpaState
  }

  set rpaState(rpaState) {
    this._data.rpaState = rpaState || 0
  }

  get rpaStateDate() {
    return this._data.rpaStateDate
  }

  set rpaStateDate(rpaStateDate) {
    this._data.rpaStateDate = rpaStateDate
  }

  get rpaStateBy() {
    return this._data.rpaStateBy
  }

  set rpaStateBy(rpaStateBy) {
    this._data.rpaStateBy = rpaStateBy || 0
  }

  get declareNum() {
    return this._data.declareNum
  }

  set declareNum(declareNum) {
    this._data.declareNum = declareNum || 0
  }

  get finalNum() {
    return this._data.finalNum
  }

  set finalNum(finalNum) {
    this._data.finalNum = finalNum || 0
  }

  get declareFinal() {
    return this._data.declareFinal
  }

  set declareFinal(declareFinal) {
    this._data.declareFinal = declareFinal || ''
  }

  get fileTotalNum() {
    return this._data.fileTotalNum
  }

  set fileTotalNum(fileTotalNum) {
    this._data.fileTotalNum = fileTotalNum || 0
  }

  get recordNum() {
    return this._data.recordNum
  }

  set recordNum(recordNum) {
    this._data.recordNum = recordNum || 0
  }

  get passNum() {
    return this._data.passNum
  }

  set passNum(passNum) {
    this._data.passNum = passNum || 0
  }

  get filetotalRecordPass() {
    return this._data.filetotalRecordPass
  }

  set filetotalRecordPass(filetotalRecordPass) {
    this._data.filetotalRecordPass = filetotalRecordPass || ''
  }

  get uploadFileId() {
    return this._data.uploadFileId
  }

  set uploadFileId(uploadFileId) {
    this._data.uploadFileId = uploadFileId || ''
  }

  get uploadFileError() {
    return this._data.uploadFileError
  }

  set uploadFileError(uploadFileError) {
    this._data.uploadFileError = uploadFileError || ''
  }

  get importResultFileId() {
    return this._data.importResultFileId
  }

  set importResultFileId(importResultFileId) {
    this._data.importResultFileId = importResultFileId || ''
  }

  get exportFileId() {
    return this._data.exportFileId
  }

  set exportFileId(exportFileId) {
    this._data.exportFileId = exportFileId || ''
  }

  get openPriceList() {
    return this._data.openPriceList
  }
  set openPriceList(openPriceList) {
    this._data.openPriceList = openPriceList || []
  }

  get oplogList() {
    return this._data.oplogList
  }
  set oplogList(oplogList) {
    this._data.oplogList = oplogList || []
  }
}
